<template>
  <v-container class="container-card">
    <v-card>
      <v-tabs v-model="tab">
        <v-tab>
          Papéis
        </v-tab>
        <v-tab>
          Níveis
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ListaPepeis />
        </v-tab-item>
        <v-tab-item>
          <ListaNiveis />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import ListaPepeis from "@/components/sistema/papeis/ListaPapeis";
import ListaNiveis from "@/components/sistema/niveis/ListaNiveis";

export default {
  name: "ConsultaModulo",

  components: {
    ListaPepeis,
    ListaNiveis
  },

  data() {
    return {
      tab: null
    };
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Papéis/Níveis");
  }
};
</script>

<style scoped>
.v-tab--active {
  background-color: white;
}
</style>
